import { Controller } from "@hotwired/stimulus"
import { subscribe } from "../lib/session_store"

export default class extends Controller {
  static targets = ["item", "badge"]

  connect() {
    this._unsubs = [
      subscribe("activeLapNumber", (lapNumber) => this._onLapChange(lapNumber)),
    ]

    // Listen for toggle events to enforce exclusive-open
    this.element.addEventListener("toggle", this._onToggle.bind(this), true)
  }

  disconnect() {
    this._unsubs?.forEach((fn) => fn())
  }

  _onToggle(event) {
    const opened = event.target
    if (!opened.open) return

    // Close all other <details> items
    this.itemTargets.forEach((item) => {
      if (item !== opened && item.open) {
        item.open = false
      }
    })
  }

  _onLapChange(lapNumber) {
    if (lapNumber == null) return

    let currentItem = null

    this.itemTargets.forEach((item) => {
      const min = Number(item.dataset.setupAccordionMin)
      const max = Number(item.dataset.setupAccordionMax)
      const isCurrent =
        !isNaN(min) && !isNaN(max) && lapNumber >= min && lapNumber <= max

      // Toggle badge visibility
      const badge = item.querySelector("[data-setup-accordion-target='badge']")
      if (badge) {
        badge.classList.toggle("hidden", !isCurrent)
      }

      if (isCurrent) currentItem = item
    })

    // Auto-open the current setup if none is open
    if (currentItem && !this.itemTargets.some((i) => i.open)) {
      currentItem.open = true
    }
  }
}
